import { MapPin, Clock, Phone, Navigation } from "lucide-react";
import { siteConfig, telHref } from "@/config/siteConfig";
import { trackEvent } from "@/lib/analytics";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { CallButton, WhatsAppButton } from "@/components/CtaButtons";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export const ContactMap = () => (
  <section id="harita" data-testid="contact-section" className="scroll-mt-20 bg-white py-20 md:py-28">
    <div className="mx-auto max-w-6xl px-5">
      <SectionHeading
        eyebrow="İletişim"
        title="Bizi Burada Bulabilirsiniz"
        testid="contact-heading"
      />
      <div className="mt-12 grid gap-6 lg:grid-cols-2">
        <Reveal>
          <div className="flex h-full flex-col rounded-3xl border border-ink-100 bg-white p-7 shadow-sm md:p-9">
            <ul className="space-y-5">
              <li className="flex items-center gap-4">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-brand-light text-brand">
                  <MapPin className="h-5 w-5" aria-hidden="true" />
                </span>
                <div>
                  <p className="text-xs font-bold uppercase tracking-widest text-neutral-400">Adres</p>
                  <p className="font-display text-base font-bold text-ink-900">
                    {siteConfig.address.locality} / {siteConfig.address.region}
                  </p>
                </div>
              </li>
              <li className="flex items-center gap-4">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-brand-light text-brand">
                  <Clock className="h-5 w-5" aria-hidden="true" />
                </span>
                <div>
                  <p className="text-xs font-bold uppercase tracking-widest text-neutral-400">Çalışma Saatleri</p>
                  <p className="font-display text-base font-bold text-ink-900">7/24 Hizmet</p>
                </div>
              </li>
              <li className="flex items-center gap-4">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-brand-light text-brand">
                  <Phone className="h-5 w-5" aria-hidden="true" />
                </span>
                <div>
                  <p className="text-xs font-bold uppercase tracking-widest text-neutral-400">Telefon</p>
                  <a
                    href={telHref}
                    data-testid="contact-phone-link"
                    onClick={() => trackEvent("phone_click", "contact")}
                    className="font-display text-base font-bold text-ink-900 underline-offset-4 hover:text-brand hover:underline"
                  >
                    {siteConfig.phone.display}
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-4">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-wa/10 text-wa-dark">
                  <WhatsAppIcon className="h-5 w-5" />
                </span>
                <div>
                  <p className="text-xs font-bold uppercase tracking-widest text-neutral-400">WhatsApp</p>
                  <p className="font-display text-base font-bold text-ink-900">{siteConfig.phone.display}</p>
                </div>
              </li>
            </ul>
            <div className="mt-8 flex flex-col gap-3">
              <CallButton location="contact" className="w-full" testid="contact-call-button" />
              <WhatsAppButton location="contact" className="w-full" testid="contact-whatsapp-button" />
              <a
                href={siteConfig.googleBusinessUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="maps-directions-button"
                onClick={() => trackEvent("directions_click", "contact")}
                className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full border-2 border-ink-900 px-7 py-3 font-display text-sm font-extrabold uppercase tracking-wide text-ink-900 transition-[background-color,color,transform] duration-200 hover:scale-[1.02] hover:bg-ink-900 hover:text-white active:scale-95"
              >
                <Navigation className="h-4 w-4" aria-hidden="true" />
                Haritada Aç
              </a>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="h-full min-h-[320px] overflow-hidden rounded-3xl border border-ink-100 shadow-sm">
            <iframe
              title="Salihli Oto Çekici — Google Haritalar konumu (Salihli, Manisa)"
              src={siteConfig.googleMapsEmbedUrl}
              data-testid="google-maps-embed"
              className="h-full min-h-[320px] w-full lg:min-h-[480px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
